module.exports = __webpack_public_path__ + "img/itx-file-type-wma.664be9c7.svg";